"use client";

import { updateAutonomy, type Settings } from "@/lib/settings-api";

interface Props {
  settings: Settings | null;
  onUpdate: (s: Settings) => void;
}

const AGENTS = [
  { id: "curator", label: "Curator", desc: "Captures & organises thoughts" },
  { id: "coach", label: "Coach", desc: "Emotional support & guidance" },
  { id: "planner", label: "Planner", desc: "Day planning & scheduling" },
];

const LEVELS = [
  { id: "full_auto", label: "Full Auto" },
  { id: "suggest_first", label: "Suggest First" },
  { id: "notify", label: "Notify Only" },
  { id: "off", label: "Off" },
];

export default function AutonomySection({ settings, onUpdate }: Props) {
  const autonomy = settings?.agent_autonomy || {};

  const handleChange = async (agent: string, level: string) => {
    const updated_autonomy = { ...autonomy, [agent]: level };
    try {
      const updated = await updateAutonomy(updated_autonomy);
      onUpdate(updated);
    } catch {
      // Ignore
    }
  };

  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm p-4" data-testid="settings-autonomy-section">
      <h2 className="text-sm font-semibold text-text-light mb-1">Agent Autonomy</h2>
      <p className="text-[10px] text-muted mb-3">Control how much each agent can do on its own</p>
      <div className="space-y-3">
        {AGENTS.map((agent) => (
          <div key={agent.id} className="flex items-center justify-between gap-2" data-testid={`settings-autonomy-row-${agent.id}`}>
            <div className="min-w-0">
              <p className="text-xs font-medium text-text-light">{agent.label}</p>
              <p className="text-[10px] text-muted">{agent.desc}</p>
            </div>
            <select
              data-testid={`settings-autonomy-select-${agent.id}`}
              aria-label={`${agent.label} autonomy`}
              value={autonomy[agent.id] || "full_auto"}
              onChange={(e) => handleChange(agent.id, e.target.value)}
              className="text-xs px-2 py-1.5 rounded-lg border border-border bg-white bg-bg
                         focus:outline-none focus:ring-2 focus:ring-forest/30 text-text-light"
            >
              {LEVELS.map((l) => (
                <option key={l.id} value={l.id}>{l.label}</option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
